function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M69.3557 34.7237C72.7782 54.3678 62.6369 68.6879 37.2144 72.5432C11.6104 75.4807 3.80207 64.2816 0.170264 38.0282C-1.28243 15.2631 6.34429 6.0836 31.4036 0.392362C51.3784 -1.62718 61.3658 3.3298 69.3557 34.7237Z",
  fill: "#F0E36C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M54.6267 47.4843H15.7896V35.6643C15.7896 33.7991 17.3015 32.2871 19.1667 32.2871H51.2495C53.1147 32.2871 54.6267 33.7991 54.6267 35.6643V47.4843Z",
  stroke: "#301D31",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3513 53.3656H19.3589C18.7864 53.3656 18.3223 52.9014 18.3223 52.3289V47.4556H23.388V52.3289C23.388 52.9014 22.9239 53.3656 22.3513 53.3656Z",
  stroke: "#301D31",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M51.0569 53.3656H48.0645C47.492 53.3656 47.0278 52.9014 47.0278 52.3289V47.4556H52.0935V52.3289C52.0935 52.9014 51.6294 53.3656 51.0569 53.3656Z",
  stroke: "#301D31",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M51.2498 32.2873H19.167L23.4109 22.6586C23.9052 21.3405 25.1653 20.4673 26.5731 20.4673H43.8438C45.2515 20.4673 46.5116 21.3405 47.0059 22.6586L51.2498 32.2873Z",
  stroke: "#301D31",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M40.9972 20.2233H30.7993L32.1483 18.1465C32.3054 17.8622 32.706 17.6738 33.1534 17.6738H38.6431C39.0906 17.6738 39.4911 17.8622 39.6482 18.1465L40.9972 20.2233Z",
  stroke: "#301D31",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M27.6099 38.1963H42.807",
  stroke: "#301D31",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5441 39.8854H20.8555C20.3892 39.8854 20.0112 39.5074 20.0112 39.0412V37.3526C20.0112 36.8863 20.3892 36.5083 20.8555 36.5083H22.5441C23.0104 36.5083 23.3884 36.8863 23.3884 37.3526V39.0412C23.3884 39.5074 23.0104 39.8854 22.5441 39.8854Z",
  stroke: "#301D31",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M49.5607 39.8854H47.8721C47.4058 39.8854 47.0278 39.5074 47.0278 39.0412V37.3526C47.0278 36.8863 47.4058 36.5083 47.8721 36.5083H49.5607C50.027 36.5083 50.405 36.8863 50.405 37.3526V39.0412C50.405 39.5074 50.027 39.8854 49.5607 39.8854Z",
  stroke: "#301D31",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

function SvgIconTaxi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 73,
    viewBox: "0 0 70 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTaxi);
export default __webpack_public_path__ + "static/media/icon_taxi.1c810149.svg";
export { ForwardRef as ReactComponent };